module.exports = __webpack_public_path__ + "media/images/lp/donation1-title-sp-77b860f5ba3fc50705565c6c3350fafb.png";